module.exports = __webpack_public_path__ + "static/media/giant.83ec9601.png";